import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Action } from '@/typeDefine/CommonTypes';


export default /*@__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: /*@__PURE__*/_mergeModels({
    totalPage: {},
    pageSize: {}
  }, {
    "currentPage": {},
    "currentPageModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["currentPageChange"], ["update:currentPage"]),
  setup(__props: any, { emit: __emit }) {

const currentPage = _useModel<number>(__props, 'currentPage')

const props = __props

const emit = __emit

const currentPageChange: Action<[number]> = (value: number) => {
    emit('currentPageChange',value)
}

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createBlock(_component_el_pagination, {
    "page-size": props.pageSize,
    "page-count": props.totalPage,
    layout: "prev, pager, next",
    "current-page": currentPage.value,
    "onUpdate:currentPage": [
      _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
      currentPageChange
    ]
  }, null, 8, ["page-size", "page-count", "current-page"]))
}
}

})